import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './joint_replacement.css';
import HowItWorks from '../how_it_works';
import FeaturedInMedia from '../featured_in_media';
import TextLeftImgRightWbg from '../hero_sections/txt_left_img_right_wbg';
import AboutHeadlineThreeIcons from '../about_headline_three_icons';
import FsLightbox from 'fslightbox-react';
import EmailSignupFooter from '../email_signup_footer';

export default function JointReplacement({}) {
  const [toggler, setToggler] = useState(false);

  return (
    <div className='joint-replacement'>
      <TextLeftImgRightWbg
        headline={'Considering hip or knee replacement?'}
        para={
          'Take a short questionnaire to talk to a recovered patient about their surgical experience or find a qualified surgeon. It’s free and easy to use!'
        }
        bg={'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/Joint+replacement+PatientPartner.jpeg'}
        actionContent={
          <div className='btn-wrap'>
            <Link to='/member/join/support'>
              <button className='maincta' data-gtm-click-label='Joint Replacement CTA Get Started'>
                Get started
              </button>
            </Link>
          </div>
        }
        imgOffset={false}
        imgShadow={true}
        topOfIcon={'70%'}
        leftOfIcon={'0%'}
        heightOfImage={'300px'}
        wrapperPadding={'50px'}
        headlineFontSize={'50px'}
        iconContent={
          <svg height='100px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132.05 163.45'>
            <g id='Layer_2' data-name='Layer 2'>
              <g id='Layer_1-2' data-name='Layer 1'>
                <path
                  fill='#74ccd3'
                  className='cls-1'
                  d='M131.9,78.63V38.83c0-5.75-.43-11.32-2.66-16.73A36,36,0,0,0,108.2,2C103.11.19,97.89,0,92.57,0H37.07C19.79,0,3.91,11.21.67,28.77-.11,33,0,37.29,0,41.59V61.06C0,72.67,0,84.29,0,95.9c.08,19.16,15.19,35.35,34.54,35.94,2.44.08,4.87,0,7.31,0l.25,0a3,3,0,0,0,2.7-1.5l.12-.13h0L68,99.44c3.92-.87,7.16-4,9.32-7.57C83.79,81.23,89.81,70.31,96,59.54c2.88-5,6.84-12.13,3.58-17.86-2.52-4.47-8.3-4.24-13.27-4a6.26,6.26,0,1,0,.09,6.69h1.1c1.58,0,5.4-.81,6.45.57s-.46,5.17-1.06,6.55a49.19,49.19,0,0,1-2.78,5.15L73.91,84.77c-1.7,2.93-3.61,7.87-7.4,8.37-3.94.52-6.06-4.15-7.69-7l-16.18-28c-1.87-3.24-6.08-8.58-4.58-12.46.87-2.26,4.84-1.28,6.77-1.28h.23a6.25,6.25,0,0,0,11.59-3.26h0a6.25,6.25,0,0,0-11.59-3.26H43.71c-3.09,0-6.29-.29-8.93,1.61-5.19,3.71-3.41,11.19-1.1,16,2.43,5.11,5.63,9.94,8.46,14.83L52.58,88.43c2.15,3.72,4.36,7.81,8.18,9.9l-20.25,27c-8,0-15.43-.65-22.22-5.68A29.34,29.34,0,0,1,6.57,96c-.1-12.3,0-24.6,0-36.9V39.68c0-5.9.25-11.59,3-17A29.4,29.4,0,0,1,35.49,6.54c3.51,0,7,0,10.52,0H89.68c4.63,0,9.34-.27,13.86.89a29.34,29.34,0,0,1,21.14,21.79c1,4.36.68,9,.68,13.44V64c0,11.24.45,22.57,0,33.81a29.25,29.25,0,0,1-17.26,25.11c-7.5,3.34-14.6,1.66-22.39,2.44-2.32.24-3.06,1.54-4.14,3.29l-4.73,7.68L65.62,154.48l-13-16.71c-2.58-3.31-7.16,1.34-4.62,4.62l15.68,20.08c1.35,1.73,4.14.95,5.13-.65L87.22,131.9c5.73.07,11.63.36,17.21-.92a35.81,35.81,0,0,0,23.17-17.71C133.31,102.72,131.9,90.2,131.9,78.63Z'
                />
              </g>
            </g>
          </svg>
        }
      />
      <FeaturedInMedia
        images={[
          'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/featured_in_media/forbes.jpg',
          'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/featured_in_media/abc.jpg',
          'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/featured_in_media/yahoo_a.jpg',
          'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/featured_in_media/nbc_a.jpg',
        ]}
      />
      <div className='marg-bottom-40 marg-top-30'>
        <AboutHeadlineThreeIcons
          bgColor='#fff'
          tileColor='#59B6BE'
          textColor='#fff'
          infoTiles={[
            {
              icon: (
                <svg
                  data-gtm-click-label={'joint replacement second fold 1:1 patient support cta'}
                  style={{ margin: '0px auto' }}
                  width='77'
                  height='52'
                  viewBox='0 0 77 52'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M54.136 29.2315C48.7204 29.3743 43.3827 30.6153 38.419 32.8858C33.4601 30.5979 28.1184 29.3561 22.7 29.2315C15.121 29.2315 0 33.1777 0 41.1068V51.1501H76.838V41.1068C76.838 33.1777 61.715 29.2315 54.136 29.2315ZM40.165 45.6744H5.239V41.1068C5.239 39.1336 14.18 34.7125 22.702 34.7125C31.224 34.7125 40.165 39.1336 40.165 41.1068V45.6744ZM71.599 45.6744H45.4V41.1068C45.3523 39.4347 44.7038 37.843 43.584 36.649C46.9801 35.4189 50.5425 34.7652 54.136 34.7125C62.658 34.7125 71.599 39.1336 71.599 41.1068V45.6744ZM22.7 25.5772C25.1178 25.5776 27.4814 24.8279 29.4918 23.4229C31.5023 22.0179 33.0694 20.0208 33.9949 17.684C34.9205 15.3472 35.1628 12.7758 34.6914 10.2949C34.2199 7.81406 33.0559 5.53516 31.3464 3.74643C29.6369 1.95771 27.4588 0.739508 25.0875 0.245888C22.7162 -0.247732 20.2583 0.00540266 18.0245 0.973279C15.7908 1.94115 13.8815 3.5803 12.5383 5.68341C11.195 7.78653 10.478 10.2592 10.478 12.7886C10.4817 16.1788 11.7705 19.429 14.0617 21.8265C16.3529 24.2239 19.4595 25.5727 22.7 25.5772ZM22.7 5.48098C24.0815 5.48098 25.432 5.90956 26.5807 6.71253C27.7293 7.5155 28.6246 8.65679 29.1533 9.99209C29.682 11.3274 29.8203 12.7967 29.5508 14.2142C29.2813 15.6318 28.616 16.9339 27.6391 17.9559C26.6623 18.9778 25.4177 19.6738 24.0627 19.9558C22.7078 20.2378 21.3033 20.093 20.027 19.5399C18.7506 18.9868 17.6597 18.0502 16.8922 16.8485C16.1247 15.6467 15.715 14.2339 15.715 12.7886C15.7205 10.8523 16.4582 8.99692 17.767 7.62773C19.0757 6.25854 20.8492 5.48677 22.7 5.48098ZM54.136 25.5772C56.5536 25.577 58.9169 24.8267 60.927 23.4214C62.9371 22.016 64.5038 20.0187 65.4288 17.6818C66.3539 15.345 66.5958 12.7737 66.124 10.293C65.6522 7.81234 64.4879 5.53374 62.7783 3.74532C61.0687 1.95691 58.8906 0.739024 56.5194 0.245658C54.1482 -0.247707 51.6904 0.00561068 49.4569 0.973579C47.2233 1.94155 45.3142 3.58069 43.9711 5.68374C42.6279 7.78679 41.911 10.2593 41.911 12.7886C41.9147 16.1793 43.2039 19.4301 45.4958 21.8276C47.7876 24.2251 50.895 25.5736 54.136 25.5772ZM54.136 5.48098C55.5175 5.48098 56.868 5.90956 58.0167 6.71253C59.1654 7.5155 60.0606 8.65679 60.5893 9.99209C61.118 11.3274 61.2563 12.7967 60.9868 14.2142C60.7173 15.6318 60.052 16.9339 59.0752 17.9559C58.0983 18.9778 56.8537 19.6738 55.4987 19.9558C54.1438 20.2378 52.7393 20.093 51.463 19.5399C50.1866 18.9868 49.0957 18.0502 48.3282 16.8485C47.5607 15.6467 47.151 14.2339 47.151 12.7886C47.1566 10.8523 47.8942 8.99692 49.203 7.62773C50.5117 6.25854 52.2852 5.48677 54.136 5.48098Z'
                    fill='white'
                  />
                </svg>
              ),
              heading: '1:1 Patient Support',
              title: 'Connect with recovered patients for information and support.',
              link: '/get-started/patient-partner-match',
              gtm: 'joint replacement second fold 1:1 patient support cta',
            },
            {
              icon: (
                <svg
                  data-gtm-click-label={'joint replacement second fold surgeon locator cta'}
                  style={{ margin: '0px auto' }}
                  width='57'
                  height='59'
                  viewBox='0 0 57 59'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M54.436 20.2874C54.4339 19.9851 54.3182 19.6957 54.1138 19.482C53.9095 19.2682 53.6329 19.1471 53.344 19.1449H39.144C38.855 19.1427 38.5785 19.0217 38.3741 18.8079C38.1698 18.5941 38.0541 18.3048 38.052 18.0025V3.14244C38.0499 2.83958 37.9337 2.5498 37.7288 2.33594C37.5238 2.12207 37.2465 2.00137 36.957 2H19.48C19.191 2.00219 18.9145 2.12326 18.7101 2.33703C18.5058 2.55081 18.3901 2.84012 18.388 3.14244V17.9983C18.3859 18.3006 18.2702 18.5899 18.0658 18.8037C17.8615 19.0175 17.585 19.1386 17.296 19.1407H3.092C2.80234 19.1429 2.5252 19.2646 2.32075 19.4793C2.1163 19.6939 2.00105 19.9843 2 20.2874V38.5716C2.00183 38.8741 2.11744 39.1637 2.3218 39.3777C2.52617 39.5917 2.80286 39.7129 3.092 39.7151H17.292C17.581 39.7173 17.8575 39.8383 18.0618 40.0521C18.2662 40.2659 18.3819 40.5552 18.384 40.8575V55.7134C18.3856 56.0168 18.5016 56.3073 18.7069 56.5216C18.9121 56.7359 19.19 56.8568 19.48 56.8579H36.957C37.246 56.8557 37.5225 56.7347 37.7268 56.5209C37.9312 56.3071 38.0469 56.0178 38.049 55.7155V40.8596C38.0511 40.5573 38.1668 40.268 38.3711 40.0542C38.5755 39.8404 38.852 39.7194 39.141 39.7172H53.341C53.6299 39.715 53.9065 39.5939 54.1108 39.3801C54.3152 39.1664 54.4309 38.877 54.433 38.5747L54.436 20.2874Z'
                    stroke='white'
                    strokeWidth='4'
                  />
                </svg>
              ),
              heading: 'Surgeon Locator',
              title: 'Find the best surgeon in your area based on your insurance.',
              link: '/get-started/surgeon-match',
              gtm: 'joint replacement second fold surgeon locator cta',
            },
          ]}
        />
      </div>
      <div className='container marg-bottom-40 wsas-wrapper'>
        <div className='row'>
          <div className='col-md-6 wsas-left'>
            <h2 className='marg-bottom-30'>What surgeons are saying</h2>
            <h3 className='marg-bottom-10'>Dr. David Fabi</h3>
            <p className='marg-bottom-20 bold'>
              Orthopedic Surgeon
              <br />
              San Diego, CA
            </p>
            <p style={{ position: 'relative' }} className='marg-bottom-20'>
              <svg
                className='wsas-quotation'
                width='37'
                height='30'
                viewBox='0 0 37 30'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M16.934 23.117C16.934 21.3335 16.43 19.8165 15.422 18.566C13.889 16.68 10.928 16.4545 9.20602 16.8235C8.49202 12.867 11.936 7.82399 16.388 5.65099L12.965 0.97699C6.24502 4.09299 -0.348977 11.268 0.785023 20.3085C1.49902 26.028 4.88002 29.8 9.66802 29.8C11.768 29.8 13.511 29.2055 14.876 27.996C16.262 26.7865 16.934 25.167 16.934 23.117ZM36.737 23.117C36.737 21.3335 36.233 19.8165 35.225 18.566C33.692 16.68 30.731 16.4545 29.009 16.8235C28.295 12.867 31.739 7.82399 36.191 5.65099L32.768 0.97699C26.048 4.09299 19.454 11.268 20.588 20.3085C21.302 26.028 24.683 29.8 29.471 29.8C31.571 29.8 33.314 29.2055 34.679 27.996C36.065 26.7865 36.737 25.167 36.737 23.117Z'
                  fill='#59B6BE'
                  fillOpacity='0.45'
                />
              </svg>
              There are a lot of fears and uncertainty going into surgery. PatientPartner will alleviate that by
              connecting you with one of the surgeon's former patients. I think this is very valuable to patients
              because we, as surgeons, want you to be as comfortable as possible going into your operation.
            </p>
            <p style={{ fontSize: '20px' }} className='marg-bottom-30 bold'>
              Get connected with a recovered patient to learn about the procedure you’re considering first hand.
            </p>
            <Link
              data-gtm-click-label='joint replacement What surgeons are saying find a patient partner cta'
              to='/member/join/support'
            >
              <button data-gtm-click-label='joint replacement What surgeons are saying find a patient partner cta'>
                Find a PatientPartner™
              </button>
            </Link>
          </div>
          <div style={{ paddingRight: '0px' }} className='col-md-6'>
            <img
              style={{ borderRadius: '8px' }}
              src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/joint-replacement/joint-replacement-doctor.jpg'
            />
          </div>
        </div>
      </div>
      <HowItWorks
        leftHead={
          <h2 className='text-left'>
            Taking the next step in your surgery is <u>easy and free</u>
          </h2>
        }
        rightHead={'How it works'}
        bublets={[
          {
            icon: (
              <svg width='359' height='344' viewBox='0 0 359 344' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M314.125 22.4375C320.076 22.4375 325.783 24.8014 329.991 29.0093C334.199 33.2171 336.562 38.9242 336.562 44.875V224.375C336.562 230.326 334.199 236.033 329.991 240.241C325.783 244.449 320.076 246.812 314.125 246.812H99.0391C87.1385 246.815 75.7262 251.545 67.3125 259.961L22.4375 304.836V44.875C22.4375 38.9242 24.8014 33.2171 29.0093 29.0093C33.2171 24.8014 38.9242 22.4375 44.875 22.4375H314.125ZM44.875 0C32.9734 0 21.5593 4.72789 13.1436 13.1436C4.72789 21.5593 0 32.9734 0 44.875L0 331.918C0.000471521 334.138 0.659496 336.308 1.89366 338.153C3.12783 339.998 4.88166 341.435 6.93317 342.283C8.98469 343.131 11.2417 343.352 13.4184 342.917C15.5952 342.481 17.5939 341.41 19.1616 339.838L83.1758 275.824C87.3827 271.616 93.0888 269.251 99.0391 269.25H314.125C326.027 269.25 337.441 264.522 345.856 256.106C354.272 247.691 359 236.277 359 224.375V44.875C359 32.9734 354.272 21.5593 345.856 13.1436C337.441 4.72789 326.027 0 314.125 0L44.875 0Z'
                  fill='black'
                />
                <path
                  d='M67.3125 78.5312C67.3125 75.5559 68.4945 72.7023 70.5984 70.5984C72.7023 68.4945 75.5559 67.3125 78.5312 67.3125H280.469C283.444 67.3125 286.298 68.4945 288.402 70.5984C290.506 72.7023 291.688 75.5559 291.688 78.5312C291.688 81.5066 290.506 84.3602 288.402 86.4641C286.298 88.568 283.444 89.75 280.469 89.75H78.5312C75.5559 89.75 72.7023 88.568 70.5984 86.4641C68.4945 84.3602 67.3125 81.5066 67.3125 78.5312ZM67.3125 134.625C67.3125 131.65 68.4945 128.796 70.5984 126.692C72.7023 124.588 75.5559 123.406 78.5312 123.406H280.469C283.444 123.406 286.298 124.588 288.402 126.692C290.506 128.796 291.688 131.65 291.688 134.625C291.688 137.6 290.506 140.454 288.402 142.558C286.298 144.662 283.444 145.844 280.469 145.844H78.5312C75.5559 145.844 72.7023 144.662 70.5984 142.558C68.4945 140.454 67.3125 137.6 67.3125 134.625ZM67.3125 190.719C67.3125 187.743 68.4945 184.89 70.5984 182.786C72.7023 180.682 75.5559 179.5 78.5312 179.5H190.719C193.694 179.5 196.548 180.682 198.652 182.786C200.756 184.89 201.938 187.743 201.938 190.719C201.938 193.694 200.756 196.548 198.652 198.652C196.548 200.756 193.694 201.938 190.719 201.938H78.5312C75.5559 201.938 72.7023 200.756 70.5984 198.652C68.4945 196.548 67.3125 193.694 67.3125 190.719Z'
                  fill='black'
                />
              </svg>
            ),
            head: 'Take a Short Questionnaire',
            para: 'Tell us about yourself so we can match you with a compatible patient or local surgeon.',
          },
          {
            icon: (
              <svg viewBox='0 0 45 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M14.8182 32.8889V32.3889H14.3182H4.09091C2.10054 32.3889 0.5 30.7667 0.5 28.7778V4.11111C0.5 2.10326 2.09892 0.5 4.09091 0.5H40.9091C42.8821 0.5 44.4998 2.10467 44.5 4.1107C44.5 4.11083 44.5 4.11097 44.5 4.11111L44.4795 28.7774V28.7778C44.4795 30.7683 42.8774 32.3889 40.9091 32.3889H30.6818H30.1818V32.8889V36.5H14.8182V32.8889ZM40.9091 29.2778H41.4091V28.7778V4.11111V3.61111H40.9091H4.09091H3.59091V4.11111V28.7778V29.2778H4.09091H40.9091Z'
                  fill='#203856'
                  stroke='white'
                />
                <path
                  d='M30.625 23.725H30.725V23.625V22.25C30.725 22.1119 30.6428 21.9722 30.5238 21.8405C30.402 21.7056 30.2273 21.5634 30.0112 21.4192C29.5784 21.1303 28.9662 20.824 28.2407 20.5442C26.7896 19.9845 24.8711 19.525 23 19.525C21.1289 19.525 19.2104 19.9845 17.7593 20.5442C17.0338 20.824 16.4216 21.1303 15.9888 21.4192C15.7727 21.5634 15.598 21.7056 15.4762 21.8405C15.3572 21.9722 15.275 22.1119 15.275 22.25V23.625V23.725H15.375H30.625ZM25.725 11C25.725 9.49477 24.5052 8.275 23 8.275C21.4948 8.275 20.275 9.49477 20.275 11C20.275 12.5052 21.4948 13.725 23 13.725C24.5052 13.725 25.725 12.5052 25.725 11ZM18.1 11C18.1 8.29273 20.2927 6.1 23 6.1C25.7073 6.1 27.9 8.29273 27.9 11C27.9 13.7073 25.7073 15.9 23 15.9C20.2927 15.9 18.1 13.7073 18.1 11ZM13.1 22.25C13.1 21.4555 13.4972 20.7521 14.161 20.1395C14.8254 19.5262 15.7503 19.0107 16.7856 18.596C18.8564 17.7664 21.3438 17.35 23 17.35C24.6562 17.35 27.1436 17.7664 29.2144 18.596C30.2497 19.0107 31.1746 19.5262 31.839 20.1395C32.5028 20.7521 32.9 21.4555 32.9 22.25V25.9H13.1V22.25Z'
                  fill='#203856'
                  stroke='white'
                  strokeWidth='0.2'
                />
              </svg>
            ),
            head: 'Review Your Recommendations',
            para: 'View your reccomendations for a local surgeon or recovered patient to take the next step in your surgery.',
          },
          {
            icon: (
              <svg viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M11.0473 7.79351L11.0451 7.78656L11.0429 7.77965C10.5827 6.38687 10.3333 4.89273 10.3333 3.33333C10.3333 2.04772 9.28562 1 8 1H3.33333C2.04772 1 1 2.04772 1 3.33333C1 16.4056 11.5944 27 24.6667 27C25.9523 27 27 25.9523 27 24.6667V20.0133C27 18.7277 25.9523 17.68 24.6667 17.68C23.1218 17.68 21.6159 17.431 20.2248 16.9719C19.3973 16.6909 18.4671 16.9053 17.8396 17.5329L15.4313 19.9412C12.3428 18.2093 9.77856 15.6534 8.05753 12.57L10.4671 10.1604C11.1154 9.51214 11.3007 8.59979 11.0473 7.79351Z'
                  stroke='#314D69'
                  strokeWidth='2'
                />
              </svg>
            ),
            head: 'Request a connection or consultation',
            para: 'Request a conversation with a patient to ask personal questions about your upcoming surgery or request a consultation with a local surgeon.',
            actionContent: (
              <Link className='marg-top-30' to='/member/join/support'>
                <button data-gtm-click-label='joint replacement How it works get started cta'>Get started</button>
              </Link>
            ),
          },
        ]}
      />
      <div className='container ppyct-wrapper'>
        <div className='row marg-top-100 marg-bottom-100 h-100'>
          <div className='col-md-7 my-auto rightside'>
            <h2 className='marg-bottom-30'>PatientPartners you can trust:</h2>
            <p className='marg-bottom-20'>
              A PatientPartner is someone that has undergone the same surgery you are prepping for.
            </p>
            <h5 className='marg-bottom-10'>What you can expect from your phone call:</h5>
            <ol className='marg-bottom-40'>
              <li>Answers to surgery-specific questions</li>
              <li>Learn what to expect throughout your surgical journey</li>
              <li>Understand the recovery process from a patient perspective</li>
            </ol>
            <Link className='marg-top-30' to='/member/join/support'>
              <button
                data-gtm-click-label='joint replacement PatientPartners you can trust find a patient partner cta'
                className='marg-bottom-30'
              >
                Find a PatientPartner™
              </button>
            </Link>
          </div>
          <div className='col-md-5 leftside my-auto'>
            <img
              className='photo-front'
              alt='patient-partner'
              src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/joint-replacement/patient-partner-joint-replacement.jpg'
            />
          </div>
        </div>
      </div>
      <div
        style={{ backgroundColor: '#EFEFEF', paddingTop: '20px', paddingBottom: '20px' }}
        className='container-fluid'
      >
        <div className='pp-sec container'>
          <div className='row justify-content-center h-100'>
            <div className='col-md-6 my-auto'>
              <div
                style={{
                  borderRadius: '8px',
                  height: '450px',
                  backgroundImage: 'url(https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/videobg.png)',
                }}
                className='video-sec container-fluid video-type-1 video-sec-wrap'
              >
                <div style={{ borderRadius: '8px' }} className='video-cover'></div>
                <div style={{ borderRadius: '8px' }} className='video-bg'>
                  <video autoPlay='autoplay' muted loop playsInline>
                    <source
                      src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/video/R5+-+Patient+Partner+Program+Value+-+D3+(1).mp4'
                      type='video/mp4'
                    />
                  </video>
                </div>
                <svg
                  onClick={() => setToggler(!toggler)}
                  className='jr-play-button'
                  xmlns='http://www.w3.org/2000/svg'
                  width='17'
                  height='21'
                  viewBox='0 0 17 21'
                >
                  <path
                    data-gtm-click-label='joint replacement We find the best surgeons for you find a surgeon play button'
                    id='Polygon_4'
                    data-name='Polygon 4'
                    d='M9.649,1.377a1,1,0,0,1,1.7,0l8.707,14.1A1,1,0,0,1,19.207,17H1.793a1,1,0,0,1-.851-1.525Z'
                    transform='translate(17) rotate(90)'
                    fill='#fff'
                  />
                </svg>
                <FsLightbox
                  toggler={toggler}
                  sources={[
                    `https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/video/R5+-+Patient+Partner+Program+Value+-+D3+(1).mp4`,
                  ]}
                  type='video'
                />
              </div>
            </div>
            <div className='col-md-6 my-auto'>
              <div className='cont'>
                <h2 style={{ fontSize: '35px' }} className='marg-bottom-20'>
                  We find the best surgeons for you
                </h2>
                <h5 className='ul-headline'>All PatientPartner™ recommended surgeons:</h5>
                <ol className='marg-bottom-20'>
                  <li>
                    <span>Have performed over 2,000 procedures and have an average of 10+ years of experience.</span>
                  </li>
                  <li>
                    <span>Will be local to you and most likely covered by your insurance.</span>
                  </li>
                  <li>
                    <span>
                      Have past patients that are ready to connect with you about their surgical experience for free.
                    </span>
                  </li>
                </ol>
                <Link to='/member/join/surgeon-match'>
                  <button
                    data-gtm-click-label='joint replacement We find the best surgeons for you find a surgeon cta'
                    className='marg-top-20 gtm-wl-match-me-to-patient-partner'
                  >
                    Find a surgeon
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmailSignupFooter
        headline={'Get your pre-operative guide for surgery!'}
        para={
          'Receive our guide for general information, what to expect, and tips on your upcoming total knee or hip replacement.'
        }
        successMessage={'Check your email inbox for information about insurance coverage!'}
        type={'DownloadGuideContacts::JointReplacement'}
        gtm={'joint replacement landing page lead magnet send now'}
      />
    </div>
  );
}
